import { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { NAV, BIZ } from "../data/site";
import { LogoMark } from "./Logo";
import { ExtLink } from "./Bits";

export const DemoBanner = () => (
  <div className="bg-sage-l text-ink" data-testid="demo-disclosure-banner">
    <p className="mx-auto max-w-7xl px-5 py-2 text-center text-[0.8rem] leading-snug sm:px-8">
      <strong className="font-semibold">Demonstration website.</strong> Denver Furnace Repair is not an operating business. Built by VisibilityReady™ to show what a finished contractor site can be.{" "}
      <Link to="/about-this-demonstration" className="underline underline-offset-2" data-testid="banner-about-demo-link">About this demonstration</Link>
    </p>
  </div>
);

const Brand = () => (
  <Link to="/" className="flex min-h-[44px] items-center gap-3 text-ink" data-testid="header-logo-link" aria-label="Denver Furnace Repair, demonstration site, home">
    <LogoMark />
    <span className="flex flex-col leading-none">
      <span className="whitespace-nowrap font-display text-xl font-semibold uppercase tracking-tight">{BIZ}</span>
      <span className="mt-1 text-[0.72rem] text-mist">(Demo Purposes Only)</span>
    </span>
    <span className="rounded-sm border border-flame-deep px-1.5 py-0.5 text-[0.7rem] font-bold tracking-[0.18em] text-flame-deep" data-testid="demo-indicator">DEMO</span>
  </Link>
);

export const Header = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  useEffect(() => { setOpen(false); }, [pathname]);

  return (
    <header className="sticky top-0 z-50 border-b border-line bg-bone/90 backdrop-blur-xl">
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-6 px-5 py-3 sm:px-8">
        <Brand />
        <nav aria-label="Primary" className="hidden xl:block">
          <ul className="flex items-center gap-1">
            {NAV.map((n) => (
              <li key={n.to}>
                <NavLink to={n.to} data-testid={`nav-${n.to.split("/").pop()}`} className={({ isActive }) => `nav-link ${isActive ? "text-flame font-semibold" : "text-ink"}`}>
                  {n.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
        <div className="flex items-center gap-2">
          <span className="hidden sm:block"><ExtLink testid="header-cta-external" className="btn-flame">Get a site like this</ExtLink></span>
          <button type="button" className="grid h-11 w-11 place-items-center rounded-full border border-line text-ink xl:hidden" aria-expanded={open} aria-controls="mobile-nav" aria-label={open ? "Close menu" : "Open menu"} onClick={() => setOpen((o) => !o)} data-testid="mobile-menu-toggle">
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>
      {open && (
        <nav id="mobile-nav" aria-label="Mobile primary" className="border-t border-line bg-bone xl:hidden" data-testid="mobile-nav">
          <ul className="mx-auto max-w-7xl px-5 py-4 sm:px-8">
            {[...NAV, { label: "Contact (demo form)", to: "/contact" }].map((n) => (
              <li key={n.to}>
                <Link to={n.to} className="flex min-h-[48px] items-center border-b border-line font-display text-2xl uppercase text-ink" data-testid={`mobile-nav-${n.to.split("/").pop()}`}>{n.label}</Link>
              </li>
            ))}
            <li className="pt-4"><ExtLink testid="mobile-cta-external" className="btn-flame w-full justify-center">Get a site like this</ExtLink></li>
          </ul>
        </nav>
      )}
    </header>
  );
};
